function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "address",
  d: "M20.9,6.2,18.393,4.265a2.108,2.108,0,0,0-.55-.25,2.148,2.148,0,0,0-.6-.1H10.028l.846,5.278h6.371a2.385,2.385,0,0,0,1.148-.352L20.9,6.9a.432.432,0,0,0,.213-.352A.437.437,0,0,0,20.9,6.2ZM8.973,1.8H7.917a.528.528,0,0,0-.528.528V6.022H3.868a2.11,2.11,0,0,0-.6.1,2.035,2.035,0,0,0-.55.249L.212,8.308a.4.4,0,0,0,0,.707l2.507,1.934a2.1,2.1,0,0,0,.55.248,2.127,2.127,0,0,0,.6.1H7.389v8.973a.528.528,0,0,0,.528.528H8.973a.528.528,0,0,0,.528-.528V2.328A.528.528,0,0,0,8.973,1.8Z",
  transform: "translate(0 -1.8)",
  fill: "#d6d6d6"
});

var SvgAddress = function SvgAddress(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.113,
    height: 19.001,
    viewBox: "0 0 21.113 19.001",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/address.12d84bcb.svg";
export { ForwardRef as ReactComponent };